import React from 'react';

import { Text } from 'react-native';
import {
  OPComponent,
  I18n,
  FormFooter,
  Container,
  Attachments,
  Navigation,
} from '../../components';
import { THEME, __WEB__, COLOR, FONT } from '../../../constants/styles';
import { OCCUPATIONAL_HEALTH_PDF } from '../../../constants/objectTypes';
import { REQUESTING } from '../../../actions/statusTypes';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { resetStatus } from '../../employer/actions';

const uploaderRef = React.createRef();

class Documents extends OPComponent {
  static options = {
    height: '70%',
    width: 610,
  };
  constructor(props) {
    super(props);

    this.state = {
      confirmationOpts: null,
    };
  }

  componentDidMount() {
    if (!this.props.requirement?.employer_requirements_id) {
      this.props.createEmployerRequirement(this.props.requirement);
    }
  }

  componentWillUnmount() {
    this.props.actions.resetStatus();
  }

  handleCancel = () => {
    Navigation.dismissAllModals();
  };

  handleSave = () => {
    uploaderRef?.current?.uploadFiles();
  };

  confirmDelete = (onConfirmed) => {
    const confirmationOpts = {
      title: 'Delete this file?',
      description: 'The file will no longer be available for patient download',
      confirm: 'Yes, delete it',
      onConfirmed: () => {
        onConfirmed();
        this._closeConfirmation();
      },
      onCancelled: this._closeConfirmation,
    };
    this.setState({ confirmationOpts });
  };
  _closeConfirmation = () => {
    this.setState({ confirmationOpts: null });
  };

  render() {
    const props = this.props;
    const footer = (
      <FormFooter onSave={this.handleSave} onCancel={this.handleCancel} saveLabel="Upload" />
    );
    return (
      <Container
        stickyFooter={footer}
        scrollView={true}
        contentContainerStyle={{ padding: 35 }}
        renderActivityOverlay={
          !props.requirement?.employer_requirements_id || this.props.fileStatus === REQUESTING
        }
        errorMessage={props.fileErrorMessage?.message}
        confirmationOpts={this.state.confirmationOpts}
      >
        <Text style={{ ...THEME.textMedium, fontSize: 18 }}>Active Documents:</Text>
        <Attachments
          ref={uploaderRef}
          objectType={OCCUPATIONAL_HEALTH_PDF}
          objectId={props.requirement?.employer_requirements_id}
          links={true}
          confirmDelete={this.confirmDelete}
        />
      </Container>
    );
  }
}

export default connect(
  function (state, ownProps) {
    const occHealthRequirements = state.screens.employer.occHealthRequirementsData;
    const requirement = occHealthRequirements.find(
      (r) => r.master_requirement_id === ownProps.requirement.master_requirement_id
    );
    return {
      occHealthRequirements,
      requirement,
      fileStatus: state.screens.components.uploads.status,
      fileErrorMessage: state.screens.components.uploads.errorMessage,
    };
  },
  function (dispatch) {
    return {
      actions: bindActionCreators(
        {
          resetStatus,
        },
        dispatch
      ),
    };
  }
)(Documents);
